export enum MidTradeEventsGridColumnId {
  MID_TRADE_EVENT_DEAL_ID = 'MID_TRADE_EVENT_DEAL_ID',
  MID_TRADE_EVENT_STATUS = 'MID_TRADE_EVENT_STATUS',
  MID_TRADE_EVENT_DIRECTION = 'MID_TRADE_EVENT_DIRECTION',
  MID_TRADE_EVENT_COLLATERAL_NAME = 'MID_TRADE_EVENT_COLLATERAL_NAME',
  MID_TRADE_EVENT_BOND_PRICE = 'MID_TRADE_EVENT_BOND_PRICE',
  MID_TRADE_EVENT_NOTIONAL = 'MID_TRADE_EVENT_NOTIONAL',
  MID_TRADE_EVENT_START_DATE = 'MID_TRADE_EVENT_START_DATE',
  MID_TRADE_EVENT_NEW_START_DATE = 'MID_TRADE_EVENT_NEW_START_DATE',
  MID_TRADE_EVENT_END_DATE = 'MID_TRADE_EVENT_END_DATE',
  MID_TRADE_EVENT_NEW_END_DATE = 'MID_TRADE_EVENT_NEW_END_DATE',
  MID_TRADE_EVENT_TERM = 'MID_TRADE_EVENT_TERM',
  MID_TRADE_EVENT_NEW_TERM = 'MID_TRADE_EVENT_NEW_TERM',
  MID_TRADE_EVENT_RATE = 'MID_TRADE_EVENT_RATE',
  MID_TRADE_EVENT_HAIRCUT = 'MID_TRADE_EVENT_HAIRCUT',
  MID_TRADE_EVENT_HAIRCUT_TYPE = 'MID_TRADE_EVENT_HAIRCUT_TYPE',
  MID_TRADE_EVENT_COLLATERAL_ISIN_OR_BUI = 'MID_TRADE_EVENT_COLLATERAL_ISIN_OR_BUI',
  MID_TRADE_EVENT_COLLATERAL_CUSIP = 'MID_TRADE_EVENT_COLLATERAL_CUSIP',
  MID_TRADE_EVENT_PRODUCT = 'MID_TRADE_EVENT_PRODUCT',
  MID_TRADE_EVENT_PRODUCT_SECTOR = 'MID_TRADE_EVENT_PRODUCT_SECTOR',
  MID_TRADE_EVENT_MARKET = 'MID_TRADE_EVENT_MARKET',
  MID_TRADE_EVENT_COLLATERAL_CURRENCY = 'MID_TRADE_EVENT_COLLATERAL_CURRENCY',
  MID_TRADE_EVENT_TRADE_DATE = 'MID_TRADE_EVENT_TRADE_DATE',
  MID_TRADE_EVENT_TRADE_TIME = 'MID_TRADE_EVENT_TRADE_TIME',
  MID_TRADE_EVENT_START_CONSIDERATION = 'MID_TRADE_EVENT_START_CONSIDERATION',
  MID_TRADE_EVENT_START_CONSIDERATION_OVERRIDE = 'MID_TRADE_EVENT_START_CONSIDERATION_OVERRIDE',
  MID_TRADE_EVENT_END_CONSIDERATION = 'MID_TRADE_EVENT_END_CONSIDERATION',
  MID_TRADE_EVENT_COUNTERPARTY_NAME = 'MID_TRADE_EVENT_COUNTERPARTY_NAME',
  MID_TRADE_EVENT_MY_ENTITY = 'MID_TRADE_EVENT_MY_ENTITY',
  MID_TRADE_EVENT_UTI = 'MID_TRADE_EVENT_UTI',
  MID_TRADE_EVENT_EFFECTIVE_DATE = '  MID_TRADE_EVENT_EFFECTIVE_DATE',
  MID_TRADE_EVENT_NEW_ISIN = 'MID_TRADE_EVENT_NEW_ISIN',
  MID_TRADE_EVENT_NEW_COLLATERAL_NAME = 'MID_TRADE_EVENT_NEW_COLLATERAL_NAME',
  MID_TRADE_EVENT_NEW_COLLATERAL_CUSIP = 'MID_TRADE_EVENT_NEW_COLLATERAL_CUSIP',
  MID_TRADE_EVENT_NEW_BOND_PRICE = 'MID_TRADE_EVENT_NEW_BOND_PRICE',
  MID_TRADE_EVENT_NEW_NOTIONAL = 'MID_TRADE_EVENT_NEW_NOTIONAL',
  MID_TRADE_EVENT_NEW_NOTIONAL_ORIGINAL = 'MID_TRADE_EVENT_NEW_NOTIONAL_TARGET',
  MID_TRADE_EVENT_NEW_NOTIONAL_DELTA = 'MID_TRADE_EVENT_NEW_NOTIONAL_DELTA',
  MID_TRADE_EVENT_NEW_RATE = 'MID_TRADE_EVENT_NEW_RATE',
  MID_TRADE_EVENT_NEW_RATE_TARGET = 'MID_TRADE_EVENT_NEW_RATE_TARGET',
  MID_TRADE_EVENT_NEW_RATE_DELTA = 'MID_TRADE_EVENT_NEW_RATE_DELTA',
  MID_TRADE_EVENT_NEW_HAIRCUT = 'MID_TRADE_EVENT_NEW_HAIRCUT',
  MID_TRADE_EVENT_NEW_HAIRCUT_TARGET = 'MID_TRADE_EVENT_NEW_HAIRCUT_TARGET',
  MID_TRADE_EVENT_NEW_HAIRCUT_DELTA = 'MID_TRADE_EVENT_NEW_HAIRCUT_DELTA',
  MID_TRADE_EVENT_NEW_HAIRCUT_TYPE = 'MID_TRADE_EVENT_NEW_HAIRCUT_TYPE',
  MID_TRADE_EVENT_REFERENCE_RATE = 'MID_TRADE_EVENT_REFERENCE_RATE',
  MID_TRADE_EVENT_FLOAT_CRYSTALLISATION_DAYS = 'MID_TRADE_EVENT_FLOAT_CRYSTALLISATION_DAYS',
  MID_TRADE_EVENT_NEW_START_CONSIDERATION = 'MID_TRADE_EVENT_NEW_START_CONSIDERATION',
  MID_TRADE_EVENT_NEW_START_CONSIDERATION_OVERRIDE = 'MID_TRADE_EVENT_NEW_START_CONSIDERATION_OVERRIDE',
  MID_TRADE_EVENT_NEW_END_CONSIDERATION = 'MID_TRADE_EVENT_NEW_END_CONSIDERATION',
  MID_TRADE_EVENT_NEW_REPO_INTEREST = 'MID_TRADE_EVENT_NEW_REPO_INTEREST',
  MID_TRADE_EVENT_EVENT_TYPE = 'MID_TRADE_EVENT_EVENT_TYPE',
  MID_TRADE_EVENT_NOTICE_PERIOD_DAYS = 'MID_TRADE_EVENT_NOTICE_PERIOD_DAYS',
  MID_TRADE_EVENT_INVESTMENT_DECISION_MAKER = 'MID_TRADE_EVENT_INVESTMENT_DECISION_MAKER',
  MID_TRADE_EVENT_EXECUTION_DECISION_MAKER = 'MID_TRADE_EVENT_EXECUTION_DECISION_MAKER',
  MID_TRADE_EVENT_LAST_UPDATED_DATE = 'MID_TRADE_EVENT_LAST_UPDATED_DATE',
  MID_TRADE_EVENT_LAST_UPDATED_TIME = 'MID_TRADE_EVENT_LAST_UPDATED_TIME',
  MID_TRADE_EVENT_LAST_UPDATED_BY = 'MID_TRADE_EVENT_LAST_UPDATED_BY',
  MID_TRADE_EVENT_SECONDARY_COLLATERAL_NAME = 'MID_TRADE_EVENT_SECONDARY_COLLATERAL_NAME',
  MID_TRADE_EVENT_NEW_SECONDARY_COLLATERAL_NAME = 'MID_TRADE_EVENT_NEW_SECONDARY_COLLATERAL_NAME',
  MID_TRADE_EVENT_FEE = 'MID_TRADE_EVENT_FEE',
  MID_TRADE_EVENT_NEW_FEE = 'MID_TRADE_EVENT_NEW_FEE',
  MID_TRADE_EVENT_STOCK_BORROWING_LENDING_TYPE = 'MID_TRADE_EVENT_STOCK_BORROWING_LENDING_TYPE',
  MID_TRADE_EVENT_NEW_STOCK_BORROWING_LENDING_TYPE = 'MID_TRADE_EVENT_NEW_STOCK_BORROWING_LENDING_TYPE',
  MID_TRADE_EVENT_MY_ENTITY_SHORT_NAME = 'MID_TRADE_EVENT_MY_ENTITY_SHORT_NAME',
  MID_TRADE_EVENT_MY_FICC_ENTITY_SHORT_NAME = 'MID_TRADE_EVENT_MY_FICC_ENTITY_SHORT_NAME',
  MID_TRADE_EVENT_FACTOR = 'MID_TRADE_EVENT_FACTOR',
  MID_TRADE_EVENT_NEW_FACTOR = 'MID_TRADE_EVENT_NEW_FACTOR',

  MID_TRADE_EVENT_ASSET_TYPE = 'MID_TRADE_EVENT_ASSET_TYPE',
  MID_TRADE_EVENT_ISSUE = 'MID_TRADE_EVENT_ISSUE',
  MID_TRADE_EVENT_MARKET_TRADE_DATE = 'MID_TRADE_EVENT_MARKET_TRADE_DATE',
  SUBMITTING_USER = 'SUBMITTING_USER'
}

export const MidTradeEventFieldNames = {
  START_DATE: 'startDate',
  START_DATE_NEGOTIATED: 'servicingSideDetails.negotiationFields.START_DATE.negotiableFieldRequired.negotiated',
  START_DATE_MODIFIED: 'servicingSideDetails.negotiationFields.START_DATE.negotiableFieldRequired.modifiedValue',
  START_DATE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.START_DATE.negotiableFieldRequired.modified',
  RERATE_DATE: 'repoInterestStartDate',
  RERATE_DATE_NEGOTIATED: 'servicingSideDetails.negotiationFields.RERATE_DATE.negotiableFieldRequired.negotiated',
  RERATE_DATE_MODIFIED: 'servicingSideDetails.negotiationFields.RERATE_DATE.negotiableFieldRequired.modifiedValue',
  RERATE_DATE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.RERATE_DATE.negotiableFieldRequired.modified',
  END_DATE: 'endDate',
  END_DATE_NEGOTIATED: 'servicingSideDetails.negotiationFields.END_DATE.negotiableFieldRequired.negotiated',
  END_DATE_MODIFIED: 'servicingSideDetails.negotiationFields.END_DATE.negotiableFieldRequired.modifiedValue',
  END_DATE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.END_DATE.negotiableFieldRequired.modified',
  NOTIONAL: 'notional',
  NOTIONAL_NEGOTIATED: 'servicingSideDetails.negotiationFields.NOTIONAL.negotiableFieldRequired.negotiated',
  NOTIONAL_MODIFIED: 'servicingSideDetails.negotiationFields.NOTIONAL.negotiableFieldRequired.modifiedValue',
  NOTIONAL_IS_MODIFIED: 'servicingSideDetails.negotiationFields.NOTIONAL.negotiableFieldRequired.modified',
  RATE: 'rate',
  RATE_NEGOTIATED: 'servicingSideDetails.negotiationFields.RATE.negotiableFieldRequired.negotiated',
  RATE_MODIFIED: 'servicingSideDetails.negotiationFields.RATE.negotiableFieldRequired.modifiedValue',
  RATE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.RATE.negotiableFieldRequired.modified',
  HAIRCUT: 'haircut',
  HAIRCUT_NEGOTIATED: 'servicingSideDetails.negotiationFields.HAIRCUT.negotiableFieldRequired.negotiated',
  HAIRCUT_MODIFIED: 'servicingSideDetails.negotiationFields.HAIRCUT.negotiableFieldRequired.modifiedValue',
  HAIRCUT_IS_MODIFIED: 'servicingSideDetails.negotiationFields.HAIRCUT.negotiableFieldRequired.modified',
  HAIRCUT_TYPE: 'haircutType',
  HAIRCUT_TYPE_NEGOTIATED: 'servicingSideDetails.negotiationFields.HAIRCUT_TYPE.negotiableFieldRequired.negotiated',
  HAIRCUT_TYPE_MODIFIED: 'servicingSideDetails.negotiationFields.HAIRCUT_TYPE.negotiableFieldRequired.modifiedValue',
  HAIRCUT_TYPE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.HAIRCUT_TYPE.negotiableFieldRequired.modified',
  START_CONSIDERATION: 'startConsideration',
  START_CONSIDERATION_NEGOTIATED: 'servicingSideDetails.negotiationFields.START_CONSIDERATION.negotiableFieldRequired.negotiated',
  START_CONSIDERATION_MODIFIED: 'servicingSideDetails.negotiationFields.START_CONSIDERATION.negotiableFieldRequired.modifiedValue',
  START_CONSIDERATION_IS_MODIFIED: 'servicingSideDetails.negotiationFields.START_CONSIDERATION.negotiableFieldRequired.modified',
  START_CONSIDERATION_OVERRIDE: 'startConsiderationOverride',
  START_CONSIDERATION_OVERRIDE_NEGOTIATED:
    'servicingSideDetails.negotiationFields.START_CONSIDERATION_OVERRIDE.negotiableFieldRequired.negotiated',
  START_CONSIDERATION_OVERRIDE_MODIFIED:
    'servicingSideDetails.negotiationFields.START_CONSIDERATION_OVERRIDE.negotiableFieldRequired.modifiedValue',
  START_CONSIDERATION_OVERRIDE_IS_MODIFIED:
    'servicingSideDetails.negotiationFields.START_CONSIDERATION_OVERRIDE.negotiableFieldRequired.modified',
  BOND_PRICE: 'bondPrice',
  BOND_PRICE_NEGOTIATED: 'servicingSideDetails.negotiationFields.BOND_PRICE.negotiableFieldRequired.negotiated',
  BOND_PRICE_MODIFIED: 'servicingSideDetails.negotiationFields.BOND_PRICE.negotiableFieldRequired.modifiedValue',
  BOND_PRICE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.BOND_PRICE.negotiableFieldRequired.modified',

  INITIATOR_INVESTMENT_DECISION_MAKER: 'initiatorInvestmentDecisionMaker',
  INITIATOR_INVESTMENT_DECISION_MAKER_NEGOTIATED:
    'servicingSideDetails.sideFields.INITIATOR_INVESTMENT_DECISION_MAKER.negotiableFieldRequired.negotiated',
  INITIATOR_INVESTMENT_DECISION_MAKER_MODIFIED:
    'servicingSideDetails.sideFields.INITIATOR_INVESTMENT_DECISION_MAKER.negotiableFieldRequired.modifiedValue',
  INITIATOR_INVESTMENT_DECISION_MAKER_IS_MODIFIED:
    'servicingSideDetails.sideFields.INITIATOR_INVESTMENT_DECISION_MAKER.negotiableFieldRequired.modified',

  INITIATOR_EXECUTION_DECISION_MAKER: 'initiatorExecutionDecisionMaker',
  INITIATOR_EXECUTION_DECISION_MAKER_NEGOTIATED:
    'servicingSideDetails.sideFields.INITIATOR_EXECUTION_DECISION_MAKER.negotiableFieldRequired.negotiated',
  INITIATOR_EXECUTION_DECISION_MAKER_MODIFIED:
    'servicingSideDetails.sideFields.INITIATOR_EXECUTION_DECISION_MAKER.negotiableFieldRequired.modifiedValue',
  INITIATOR_EXECUTION_DECISION_MAKER_IS_MODIFIED:
    'servicingSideDetails.sideFields.INITIATOR_EXECUTION_DECISION_MAKER.negotiableFieldRequired.modified',

  RESPONDER_INVESTMENT_DECISION_MAKER: 'responderInvestmentDecisionMaker',
  RESPONDER_INVESTMENT_DECISION_MAKER_NEGOTIATED:
    'servicingSideDetails.sideFields.RESPONDER_INVESTMENT_DECISION_MAKER.negotiableFieldRequired.negotiated',
  RESPONDER_INVESTMENT_DECISION_MAKER_MODIFIED:
    'servicingSideDetails.sideFields.RESPONDER_INVESTMENT_DECISION_MAKER.negotiableFieldRequired.modifiedValue',
  RESPONDER_INVESTMENT_DECISION_MAKER_IS_MODIFIED:
    'servicingSideDetails.sideFields.RESPONDER_INVESTMENT_DECISION_MAKER.negotiableFieldRequired.modified',

  RESPONDER_EXECUTION_DECISION_MAKER: 'responderExecutionDecisionMaker',
  RESPONDER_EXECUTION_DECISION_MAKER_NEGOTIATED:
    'servicingSideDetails.sideFields.RESPONDER_EXECUTION_DECISION_MAKER.negotiableFieldRequired.negotiated',
  RESPONDER_EXECUTION_DECISION_MAKER_MODIFIED:
    'servicingSideDetails.sideFields.RESPONDER_EXECUTION_DECISION_MAKER.negotiableFieldRequired.modifiedValue',
  RESPONDER_EXECUTION_DECISION_MAKER_IS_MODIFIED:
    'servicingSideDetails.sideFields.RESPONDER_EXECUTION_DECISION_MAKER.negotiableFieldRequired.modified',
  SECONDARY_BASKET_ID: 'secondaryBasketId',
  SECONDARY_BASKET_ID_NEGOTIATED: 'servicingSideDetails.negotiationFields.SECONDARY_BASKET_ID.negotiableFieldRequired.negotiated',
  SECONDARY_BASKET_ID_MODIFIED: 'servicingSideDetails.negotiationFields.SECONDARY_BASKET_ID.negotiableFieldRequired.modifiedValue',
  SECONDARY_BASKET_ID_IS_MODIFIED: 'servicingSideDetails.negotiationFields.SECONDARY_BASKET_ID.negotiableFieldRequired.modified',
  FEE: 'fee',
  FEE_NEGOTIATED: 'servicingSideDetails.negotiationFields.FEE.negotiableFieldRequired.negotiated',
  FEE_MODIFIED: 'servicingSideDetails.negotiationFields.FEE.negotiableFieldRequired.modifiedValue',
  FEE_IS_MODIFIED: 'servicingSideDetails.negotiationFields.FEE.negotiableFieldRequired.modified',
  ROE: 'rightOfExit',
  ROS: 'rightOfSubstitution'
}
